import classNames from 'classnames';
import React, {ReactNode} from 'react';
import {useTrackFont} from '../../../containers/DataContainer/siteSettings/withTrackFont';
import {withoutSize} from '../../../services/env/siteSettings/fonts/fonts';
import styles from './SmallParagraph.scss';

interface Props {
  children: ReactNode;
  className?: string;
  dataHook?: string;
}

export const SmallParagraph: React.FunctionComponent<Props> = ({className, children, dataHook = 'smallParagraph'}) => {
  const trackFont = useTrackFont();
  return (
    <p className={classNames(styles.smallParagraph, className)} style={withoutSize(trackFont)} data-hook={dataHook}>
      {children}
    </p>
  );
};
